const COOKIE_INFO_SELECTOR = '.cookie-info';
const COOKIE_INFO_CLOSE_SELECTOR = '.cookie-info-close';

function hideCookieInfo() {
    localStorage.setItem('gk_cookie_info_closed', "true")
    document.querySelector(COOKIE_INFO_SELECTOR).classList.remove('show');
}

function showCookieInfo() {
    const status = localStorage.getItem('gk_cookie_info_closed');
    if (!status) {
        document.querySelector(COOKIE_INFO_SELECTOR).classList.add('show');
    }
}

// hide cookie info on close btn click
const cookieClose = document.querySelector(COOKIE_INFO_CLOSE_SELECTOR);
if (cookieClose) {
    cookieClose.addEventListener('click', hideCookieInfo)
}

// show cookie info on init
showCookieInfo();
